import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-32 border-t border-white/5 bg-[#050505] relative overflow-hidden">
      <div className="cw-orb" style={{ background: "#FF6B00", width: 400, height: 400, left: "-100px", bottom: "-200px" }} />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-8 relative z-10">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="h-8 w-8 rounded-md bg-[#FF6B00] flex items-center justify-center font-display font-bold">C</div>
            <span className="font-display text-lg">CreativeWayz</span>
          </div>
          <p className="text-white/50 max-w-sm text-sm">Where Brands Buy Scripts & Writers Earn. India's premium marketplace for ad scripts, viral hooks and UGC.</p>
        </div>
        <div>
          <div className="cw-label mb-3">Product</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/marketplace">Marketplace</Link></li>
            <li><Link to="/writers">Become a Writer</Link></li>
            <li><a href="/#pricing">Pricing</a></li>
          </ul>
        </div>
        <div>
          <div className="cw-label mb-3">Company</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><a href="/#faq">FAQ</a></li>
            <li><a href="mailto:hello@creativewayz.in">Contact</a></li>
            <li><a href="#">Terms</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-white/40">© {new Date().getFullYear()} CreativeWayz. All rights reserved.</div>
    </footer>
  );
}
